export interface Segment {
  text: string;
  metric: boolean;
}

// A number that starts a word, with optional decimals, an optional "→ n" range,
// and an optional %, K, M or + suffix: 80%, 4.2, 70K, 2M+, 200+, 0→1.
const METRIC = /\b\d+(?:\.\d+)?(?:\s?→\s?\d+(?:\.\d+)?)?(?:%|[KM]\+?|\+)?/g;

export function splitMetrics(text: string): Segment[] {
  const segments: Segment[] = [];
  const pattern = new RegExp(METRIC.source, 'g');
  let cursor = 0;
  let match: RegExpExecArray | null;

  while ((match = pattern.exec(text)) !== null) {
    if (match.index > cursor) segments.push({ text: text.slice(cursor, match.index), metric: false });
    segments.push({ text: match[0], metric: true });
    cursor = match.index + match[0].length;
  }

  if (cursor < text.length) segments.push({ text: text.slice(cursor), metric: false });
  return segments;
}
